'use client';

import { useTranslations } from 'next-intl';

import { BusinessEmailLayout } from '../components';

const Content = () => {
  const t = useTranslations();

  return (
    <BusinessEmailLayout
      title={t('eop_maintenance_title')}
      description={t('eop_maintenance_description')}
      isMaintenance={true}
    />
  );
};

export default Content;
